import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import { ProDomain, ProDomainsList } from 'PMT/entities/security';

// -- views
import ProDomainRow from './ProDomainRow';

export default class ChooseProDomainView extends Component {

  static propTypes = {
    proDomainsList: PropTypes.objectOf(ProDomainsList).isRequired,

    selectedProDomain: PropTypes.objectOf(ProDomain).isRequired,

    onClick: PropTypes.func.isRequired
  };

  //
  // Renderers
  //

  render() {
    return (
      <div
        className='choose_pro_domain_view'
      >
        {this.props.proDomainsList.domains.map((proDomain: ProDomain) => {
          const isSelected = this.props.selectedProDomain.id === proDomain.id;

          return React.createElement(ProDomainRow, {
            key: proDomain.id,
            isSelected,
            proDomain,
            onClick: this.props.onClick
          });
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/header/components/ChooseProDomainView.js